import {
    Action,
    FIRST_TIME_SIGNIN,
    SET_USERNAME,
    SIGNING_IN_USER,
} from '../../actions';
import { IVerifyTppEmailResponse } from '../../reduxTypes';


export interface AssistantState {
    loggedIn: boolean,
    pending: boolean
    rejected: boolean
    redirect?: boolean
    disabledBanner: boolean
    username: string
    email: string
    token: string | null,
    acr: string,
    hasLoggedIn?: boolean
}

export const initialTokenState: AssistantState = {
    loggedIn: false,
    pending: false,
    redirect: false,
    rejected: false,
    username: '',
    email: '',
    acr: '',
    token: null,
    disabledBanner: false,
}

export const SIGNED_OUT_USER = 'SIGNED_OUT_USER';
export const INIT_SIGNIN = 'INIT_SIGNIN'


/**
 * Reducer responsible for managing results from TokenAssistant
 * @param state State of user before action was created
 * @param action Should the user be logged in or not
 * @returns 
 */
export const tokenAssistantReducer = (state = initialTokenState, action: Action) => {
    switch (action.type) {
        case `${SIGNING_IN_USER}_PENDING`:
            return { ...state, pending: true, rejected: false };
        case `${SIGNING_IN_USER}_FULFILLED`:
            return { ...state, loggedIn: true, token: action.payload.token, username: action.payload.username, email: action.payload.email, acr: action.payload.acr, pending: false, redirect: false, rejected: false, hasLoggedIn: true };
        case `${SIGNING_IN_USER}_REJECTED`:
            return { ...state, loggedIn: false, token: null, pending: false, redirect: false, rejected: true };
        case `${INIT_SIGNIN}_PENDING`:
            return { ...state, pending: true, rejected: false };
        case `${INIT_SIGNIN}_FULFILLED`:
            return { ...state };
        case `${INIT_SIGNIN}_REJECTED`:
            return { ...state, loggedIn: false, token: null, pending: false, redirect: false, rejected: true };
        case `${FIRST_TIME_SIGNIN}_PENDING`:
            return { ...state, pending: true, rejected: false };
        case `${FIRST_TIME_SIGNIN}_REJECTED`:
            return { ...state, loggedIn: false, token: null, pending: false, rejected: true };
        case `${FIRST_TIME_SIGNIN}_FULFILLED`:
            return { ...state, loggedIn: true, token: action.payload.token, username: action.payload.username, email: action.payload.email, acr: action.payload.acr, pending: false, redirect: true, rejected: false, hasLoggedIn: true };
        case SIGNED_OUT_USER:
            return { ...initialTokenState, rejected: true, hasLoggedIn: state.hasLoggedIn }
        case 'PREVENT_REDIRECT':
            return { ...state, redirect: false }
        case SET_USERNAME:
            return { ...state, username: action.payload.name, email: action.payload.email }
        default: return state;
    }
}

export const VERIFY_EMAIL = 'VERIFY_EMAIL'
export interface IVerifyEmailState {
    loading: boolean,
    error: boolean,
    data: IVerifyTppEmailResponse | null
}

export const initialVerifyEmailState: IVerifyEmailState = {
    loading: false,
    error: false,
    data: null
}
export const verifyEmailReducer = (state = initialVerifyEmailState, action: Action) => {
    switch (action.type) {
        case `${VERIFY_EMAIL}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${VERIFY_EMAIL}_REJECTED`:
            return { ...state, loading: false, error: true };
        case `${VERIFY_EMAIL}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        default: return state;
    }
}

export interface IUserState {
    loading: boolean,
    error: boolean,
    data: any,
    verified: boolean,
}

const initialUserState: IUserState = {
    loading: false,
    error: false,
    data: null,
    verified: true, //This is the most common case, despite everyone initally starting with this false
}

export const GET_USER = 'GET_USER';
export const USER_ERROR = 'USER_ERROR'
export const CREATE_USER = 'CREATE_USER';
export const EMAIL_VERIFIED = 'EMAIL_VERIFIED';
export const EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED';
export const FLUSH_USER = 'FLUSH_USER';



export function getUserReducer(state = initialUserState, action: Action): IUserState {
    switch (action.type) {
        case `${GET_USER}_PENDING`:
            return { ...state, loading: true, error: false }
        case `${GET_USER}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${GET_USER}_REJECTED`:
            return { ...state, loading: false, error: true }
        case EMAIL_NOT_VERIFIED:
            return { ...state, verified: false }
        case EMAIL_VERIFIED:
            return { ...state, verified: true }
        case SIGNED_OUT_USER:
            return initialUserState
        default: return { ...state }
    }
}

export interface ICreateUserState {
    loading: boolean,
    error: boolean,
    data: any,
    flushed: boolean,
}

const initialCreateUserState: ICreateUserState = {
    loading: false,
    error: false,
    data: null,
    flushed: false
}

export function createUserReducer(state = initialCreateUserState, action: Action): ICreateUserState {
    switch (action.type) {
        case `${CREATE_USER}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${CREATE_USER}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload, flushed: false };
        case `${CREATE_USER}_REJECTED`:
            return { ...state, loading: false };
        case USER_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case FLUSH_USER:
            return { ...state, flushed: true, error: false };
        case SIGNED_OUT_USER:
            return initialCreateUserState;
        default: return state
    }
}